var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.358,
    height: 23.052,
    viewBox: "0 0 25.358 23.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-live-tv",
    "data-name": "Icon material-live-tv",
    d: "M24.552,7.61H15.8L19.6,3.818,18.789,3l-4.61,4.61L9.568,3l-.818.818,3.8,3.792H3.805A2.3,2.3,0,0,0,1.5,9.916V23.747a2.312,2.312,0,0,0,2.305,2.305H24.552a2.312,2.312,0,0,0,2.305-2.305V9.916A2.3,2.3,0,0,0,24.552,7.61Zm0,16.137H3.805V9.916H24.552ZM10.721,12.221v9.221l8.068-4.61Z",
    transform: "translate(-1.5 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLive);
export default __webpack_public_path__ + "static/media/Icon_live.c7c97ba6de955e43edbeb46c5c98c5b4.svg";
export { ForwardRef as ReactComponent };